import React, {useEffect, useState} from 'react';

import {
  ButtonProps, BUTTON_TYPE, BUTTON_SIZE, BUTTON_HTML_TYPE,
} from './types';
import {StyledButton} from './style';

const Button = ({
  isLoading = false,
  htmlType = BUTTON_HTML_TYPE.BUTTON,
  type = BUTTON_TYPE.PLAIN,
  size = BUTTON_SIZE.DEFAULT,
  onClick,
  isFullWidth = false,
  elementId,
  isAsync = false,
  isDisabled = false,
  children,
  gtmAction = undefined,
  gtmLabel = undefined,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
}: ButtonProps) => {
  const [isStateLoading, setLoading] = useState<boolean>(isLoading);
  const isMounted = React.useRef<boolean>(true);

  useEffect(() => () => {
    isMounted.current = false;
  }, []);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  async function onClickAsync() {
    try {
      setLoading(true);
      await onClick();
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  }

  function onClickLocal() {
    if (!isAsync) {
      onClick();
      return;
    }

    onClickAsync();
  }

  return (
    <StyledButton
      type={htmlType}
      styledType={type}
      size={size}
      onClick={onClickLocal}
      isDisabled={isStateLoading || isDisabled}
      id={elementId}
      className="Button"
      gtm-action={gtmAction}
      gtm-label={gtmLabel}
      data-is-loading={isStateLoading}
      isLoading={isLoading || isStateLoading}
      isFullWidth={isFullWidth}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </StyledButton>
  );
};

export default Button;

export {BUTTON_TYPE, BUTTON_SIZE, BUTTON_HTML_TYPE};
